"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prefer-promise-reject-errors */
var axios_1 = __importDefault(require("axios"));
var utilities_1 = require("../utilities");
var constants_1 = require("../constants");
var CookieProvider_1 = __importDefault(require("./CookieProvider"));
function getBundledExperiments(environment, experiments, identifier, _a, shouldUseK8sUrl, apiTimeoutMS) {
    var serverHeaders = _a.serverHeaders;
    var baseUrl = utilities_1.getBaseUrl(environment, shouldUseK8sUrl);
    var xForwardedFor = serverHeaders['x-forwarded-for'] || null;
    var headers = __assign({}, (xForwardedFor && { 'x-forwarded-for': xForwardedFor }));
    return axios_1.default({
        method: 'post',
        url: "https://" + baseUrl + "/api/v2/buckets/bundle",
        data: {
            experiments: experiments,
            identifier: identifier
        },
        headers: headers,
        timeout: apiTimeoutMS
    });
}
function FetchMultipleExperimentsWithIdentifier(_a) {
    var logError = _a.logError, params = __rest(_a, ["logError"]);
    return __awaiter(this, void 0, void 0, function () {
        var experiments, identifier, _b, environment, _c, cacheMinutes, _d, apiTimeoutMS, killSwitch, serverHeaders, shouldUseK8sUrl, undefinedBuckets, response, bucketedExperiments, bucketAssignments, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    experiments = params.experiments, identifier = params.identifier, _b = params.environment, environment = _b === void 0 ? process.env.NODE_ENV : _b, _c = params.cacheMinutes, cacheMinutes = _c === void 0 ? constants_1.CACHE_MINUTES : _c, _d = params.apiTimeoutMS, apiTimeoutMS = _d === void 0 ? constants_1.API_TIMEOUT : _d, killSwitch = params.killSwitch, serverHeaders = params.serverHeaders, shouldUseK8sUrl = params.shouldUseK8sUrl;
                    undefinedBuckets = experiments.map(function (experiment) { return ({
                        experimentName: experiment,
                        assignedBucket: undefined
                    }); });
                    if (killSwitch === 'on') {
                        return [2 /*return*/, undefinedBuckets];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getBundledExperiments(environment, experiments, identifier, { serverHeaders: serverHeaders }, shouldUseK8sUrl, apiTimeoutMS)];
                case 2:
                    response = _e.sent();
                    bucketedExperiments = response.data.content.bucketedExperiments;
                    bucketAssignments = bucketedExperiments.map(function (_a) {
                        var bucketName = _a.bucketName, experimentName = _a.experimentName;
                        return ({
                            assignedBucket: bucketName,
                            experimentName: experimentName
                        });
                    });
                    if (cacheMinutes !== 0) {
                        bucketAssignments.forEach(function (_a) {
                            var assignedBucket = _a.assignedBucket, experimentName = _a.experimentName;
                            CookieProvider_1.default.set({
                                name: experimentName,
                                value: assignedBucket,
                                cacheMinutes: cacheMinutes
                            });
                        });
                    }
                    return [2 /*return*/, bucketAssignments];
                case 3:
                    error_1 = _e.sent();
                    if (logError) {
                        logError("Error fetching bucket assignments from '/api/v2/buckets/bundle'", { error: error_1, params: params });
                    }
                    if (environment !== 'production') {
                        console.error("Error fetching bucket assignments from '/api/v2/buckets/bundle' [only logged in non-prod envs]:", error_1);
                    }
                    return [2 /*return*/, undefinedBuckets];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.default = FetchMultipleExperimentsWithIdentifier;
